import { render, staticRenderFns } from "./ParameterForm.vue?vue&type=template&id=60ced84c&scoped=true"
import script from "./ParameterForm.vue?vue&type=script&lang=js"
export * from "./ParameterForm.vue?vue&type=script&lang=js"
import style0 from "./ParameterForm.vue?vue&type=style&index=0&id=60ced84c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ced84c",
  null
  
)

export default component.exports